import { render } from "./AdBox.vue?vue&type=template&id=76a0be86&scoped=true"
import script from "./AdBox.vue?vue&type=script&lang=js"
export * from "./AdBox.vue?vue&type=script&lang=js"

import "./AdBox.vue?vue&type=style&index=0&id=76a0be86&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-76a0be86"

export default script